import {
  ChangeDetectionStrategy,
  Component,
  Input,
  output,
} from '@angular/core';

import { MultiLanguageActionComponent } from '../../atoms/action-button/action-button.component';
import { MultilanguageLabelWrapperComponent } from '../../atoms/label-wrapper/label-wrapper.component';
import { MultilanguageIconsComponent } from '../../atoms/language-icons/language-icons.component';
import { MultilanguageRemoveComponent } from '../../atoms/remove-language/remove-language.component';
import { MultilanguageLabelComponent } from '../language-label/language-label.component';

export type EntryData = {
  active: boolean;
  selectTooltip: string;
  removeTooltip: string;
  selectDisabled: boolean;
  showRemove: boolean;
  removeDisabled: boolean;
  selectAria: string;
  removeAria: string;
  languageLabel: string;
  languageAvailable: boolean;
  languageCode: string;
  languageErrors: boolean | undefined;
};

@Component({
  selector: 'plugins-multilanguage-entry',
  imports: [
    MultilanguageLabelWrapperComponent,
    MultiLanguageActionComponent,
    MultilanguageLabelComponent,
    MultilanguageRemoveComponent,
    MultilanguageIconsComponent,
  ],
  template: `
    <plugins-multilanguage-label-wrapper [active]="data.active">
      <plugins-multilanguage-action
        [tooltip]="data.selectTooltip"
        [ariaLabel]="data.selectAria"
        [disabled]="data.selectDisabled"
        (clicked)="selected.emit()"
      >
        <plugins-multilanguage-icons [lang]="data.languageCode" />
        <plugins-multilanguage-label
          [language]="data.languageLabel"
          [available]="data.languageAvailable"
          [hasError]="data.languageErrors"
        />
      </plugins-multilanguage-action>
      @if (data.showRemove) {
        <plugins-multilanguage-remove
          [tooltip]="data.removeTooltip"
          [ariaLabel]="data.removeAria"
          [disabled]="data.removeDisabled"
          (clicked)="removed.emit()"
        />
      }
    </plugins-multilanguage-label-wrapper>
  `,
  styleUrl: './language-entry.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultilanguageEntryComponent {
  @Input() data!: EntryData;
  readonly selected = output();
  readonly removed = output();
}
